// Value of the transfer target for "no perimeter", as the api expects it in
// the usage query (the archive body sends null instead).
export const NO_PERIMETER_TARGET = 'none';

export const PERIMETER_MODALS = {
  create: 'company_perimeter_create',
  edit: 'company_perimeter_edit',
  delete: 'company_perimeter_delete',
  archive: 'company_perimeter_archive',
  archiveTransfer: 'company_perimeter_archive_transfer',
  restore: 'company_perimeter_restore',
  addToMember: 'company_member_add_perimeters',
};

// What a perimeter modal returns once its write is done: the block reloads.
export const PERIMETERS_CHANGED = 'company_perimeters_changed';

// What the « Ajouter des périmètres » modal returns: ids for the contact
// screen's draft, nothing written yet.
export const MEMBER_PERIMETERS_PICKED = 'company_member_perimeters_picked';

// The usage decides which modal the archive button opens: a perimeter that
// never carried a mission is deleted, one with nothing left to move is simply
// archived, and one with active missions or members needs a destination.
export const getArchiveModalType = (usage) => {
  if (!usage.usedAt) return PERIMETER_MODALS.delete;
  if (!usage.activeMissions && !usage.members) return PERIMETER_MODALS.archive;
  return PERIMETER_MODALS.archiveTransfer;
};
